import ImportRequests from './ImportRequests';
import ImportRequestsProvider from './ImportRequestsContext';


let Index = () => {
    return (
        <ImportRequestsProvider>
            <ImportRequests />
        </ImportRequestsProvider>
    );
}

export default Index;